import { PackageData } from '../types';

export enum PackagesGridEvents {
  OnAddPackage = 'packagesGridAddPackage',
  OnClickPackage = 'packagesGridClickPackage',
}

export class OnAddPackage extends CustomEvent<{}> {
  constructor() {
    super(PackagesGridEvents.OnAddPackage, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}

export class OnClickPackage extends CustomEvent<{ packageData: PackageData }> {
  constructor(packageData: PackageData) {
    super(PackagesGridEvents.OnClickPackage, {
      detail: {
        packageData,
      },
      bubbles: true,
      composed: true,
    });
  }
}
